document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 1000);
    }
  });
});